import DxWorkspace from '../../features/pregnancies/layouts/dx';

// TSS vite/01 §"Pages are thin". Worklist de diagnóstico de preñez (por finca).
export default function DxPage() {
    return <DxWorkspace />;
}
